import type { ReactNode } from 'react'

import { CockpitCardHeader } from '../cockpitCardHeader'
import { CockpitExportButton } from '../cockpitExport'
import { CockpitIconButton } from '../cockpitIconButton'

interface ICockpitTileTitleProps {
  title: string
  expanded: boolean
  onToggle: () => void
  children?: ReactNode
  /** The tile's own controls, placed in the header's control row before the shared ones. */
  actions?: ReactNode
  /** Drops the expand control while collapsed, for tiles whose own rows expand them. */
  hideToggleWhenCollapsed?: boolean
  /** Adds a control that opens the tile over the whole screen, after the expand control. */
  fullscreen?: { label: string; onOpen: () => void }
}

/** A tile's own header: `CockpitCardHeader` filled with the two acts every tile carries. */
export const CockpitTileTitle = ({
  title,
  expanded,
  onToggle,
  children,
  actions,
  hideToggleWhenCollapsed = false,
  fullscreen,
}: ICockpitTileTitleProps) => {
  const toggleLabel = expanded ? 'Show summary' : 'Show detailed'

  return (
    <CockpitCardHeader
      title={title}
      description={children}
      actions={
        <>
          {actions}
          {expanded && <CockpitExportButton />}
          {(expanded || !hideToggleWhenCollapsed) && (
            <CockpitIconButton
              icon={expanded ? 'kbase kbase-compress' : 'kbase kbase-expand'}
              label={toggleLabel}
              expanded={expanded}
              onClick={onToggle}
            />
          )}
          {fullscreen && (
            <CockpitIconButton
              icon="kbase kbase-full-screen"
              label={fullscreen.label}
              onClick={fullscreen.onOpen}
            />
          )}
        </>
      }
    />
  )
}

CockpitTileTitle.displayName = 'CockpitTileTitle'
